import { createFeature, createReducer, on } from '@ngrx/store';
import { AddTarResponseI } from '../../api/add-tar/add-tar.result.int';
import * as actions from './add-tar.actions';
import * as luxon from 'luxon';

  export interface AddTarState {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: AddTarResponseI;
    receivedTime: string;
}

export const initialState: AddTarState = {
    error: null,
    loaded: false,
    loading: false,
    data: null,
    receivedTime: null,
};

export default createFeature({
  name: 'addTar',
  reducer: createReducer(
  initialState,
  on(actions.loadAddTarAction, (state: AddTarState): AddTarState => ({
    ...state,
    loaded: false,
    loading: true
  })),
  on(actions.received, (state: AddTarState, { data }): AddTarState => ({
    ...state,
    data,
    error: null,
    loaded: true,
    loading: false,
    receivedTime: luxon.DateTime.now().toISO()
  })),
  on(actions.resetAddTarAction, (state: AddTarState): AddTarState => ({
    ...state,
    data: null,
    error: null,
    loaded: false,
    loading: false
  })),
  on(actions.error, (state: AddTarState, { messageText }): AddTarState => ({
    ...state,
    error: messageText,
    loaded: false,
    loading: false
  })),
)});
